export const toDecimal = (value: any) => {
  if (value === null || value === undefined) return null;

  if (typeof value === 'number') return value;

  const parsed = Number(value.toString().trim().replace(',', '.'));
  return isNaN(parsed) ? null : parsed;
};
